import PropTypes from 'prop-types'
import {Button, Flex, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

const SupportRequestReceivedScreen = ({onDone}) => {
  const {t} = useTranslation('connectPayoutAccount')

  return (
    <Flex justify="center">
      <Flex flexDirection="column" width="400px" gap={4} pt={20}>
        <Text
          color="black"
          fontWeight="regular"
          fontSize="4xl"
          lineHeight="105%"
          mt={12}
        >
          {t('modal.supportRequestReceived.title')}
        </Text>

        <Text
          color="black"
          fontWeight="medium"
          fontSize="sm"
          lineHeight="125%"
          pt={6}
        >
          {t('modal.supportRequestReceived.description')}
        </Text>

        <Flex pt={4}>
          <Button
            borderRadius="full"
            variant="secondary"
            onClick={onDone}
            _hover={{}}
          >
            {t('modal.buttons.close')}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

SupportRequestReceivedScreen.propTypes = {
  onDone: PropTypes.func.isRequired,
}

export default SupportRequestReceivedScreen
